
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $crTlg = parcelRequire("crTlg");
var $e67a97453a06b1d3$export$3d7865934588d77e = /*#__PURE__*/ function(EventType) {
    EventType[EventType["NEXT_EVENT"] = 0] = "NEXT_EVENT";
    EventType[EventType["PREVIOUS_EVENT"] = 1] = "PREVIOUS_EVENT";
    EventType[EventType["TOGGLE_DOT_EVENT"] = 2] = "TOGGLE_DOT_EVENT";
    return EventType;
}({});
var $e67a97453a06b1d3$export$92738401e1603719 = /*#__PURE__*/ function(Type) {
    Type[Type["INITIAL"] = 0] = "INITIAL";
    Type[Type["REVIEW"] = 1] = "REVIEW";
    Type[Type["LAST"] = 2] = "LAST";
    Type[Type["SUBMIT"] = 3] = "SUBMIT";
    Type[Type["CANCEL"] = 4] = "CANCEL";
    return Type;
}({});
function $e67a97453a06b1d3$export$2196def6041a3ef8(state) {
    const virtues = state.virtues;
    const index = state.virtueIndex;
    const virtue = virtues.at(index);
    (0, $crTlg.assertIsDefined)(virtue);
    return virtue;
}
function $e67a97453a06b1d3$export$d4c72bab9d6cc13a(virtues, markedVirtues, userEmail) {
    const state = {
        markedVirtues: markedVirtues,
        type: 0,
        userEmail: userEmail,
        virtueIndex: 0,
        virtues: virtues
    };
    switch(virtues.length){
        case 0:
            return {
                ...state,
                type: 4
            };
        case 1:
            return {
                ...state,
                type: 2
            };
        default:
            return {
                ...state,
                type: 0
            };
    }
}
function $e67a97453a06b1d3$export$db8f131360c543a5(virtue, state) {
    return state.markedVirtues.find((name)=>name == virtue.name) != undefined;
}
function $e67a97453a06b1d3$export$bbfb8c6919cdf161(event, state) {
    const virtueIndex = $e67a97453a06b1d3$var$getVirtueIndex(state);
    switch(event){
        case 0:
            if (virtueIndex == state.virtues.length - 1) return {
                ...state,
                type: 3
            };
            else if (virtueIndex == state.virtues.length - 2) return {
                ...state,
                type: 2,
                virtueIndex: virtueIndex + 1
            };
            else return {
                ...state,
                type: 1,
                virtueIndex: virtueIndex + 1
            };
        case 1:
            if (virtueIndex == 0) return {
                ...state,
                type: 4
            };
            else if (virtueIndex == 1) return {
                ...state,
                type: 0,
                virtueIndex: virtueIndex - 1
            };
            else return {
                ...state,
                type: 1,
                virtueIndex: virtueIndex - 1
            };
        case 2:
            {
                const virtue = $e67a97453a06b1d3$export$2196def6041a3ef8(state);
                const markedVirtues = state.markedVirtues;
                $e67a97453a06b1d3$var$toggleVirtue(markedVirtues, virtue);
                return {
                    ...state,
                    markedVirtues: markedVirtues
                };
            }
    }
}
function $e67a97453a06b1d3$export$a950cf0065bb6a87(state) {
    return state.markedVirtues;
}
function $e67a97453a06b1d3$export$93e1ccb4dacd4b3d(state) {
    return state.userEmail;
}
function $e67a97453a06b1d3$var$getVirtueIndex(state) {
    return state.virtueIndex;
}
// Once we start using immutable data structure we can make this more pure
function $e67a97453a06b1d3$var$toggleVirtue(markedVirtues, virtue) {
    const index = markedVirtues.findIndex((name)=>name == virtue.name);
    if (index < 0) markedVirtues.push(virtue.name);
    else markedVirtues.splice(index, 1);
}



var $3GmSf = parcelRequire("3GmSf");

var $6tuu1 = parcelRequire("6tuu1");

var $crTlg = parcelRequire("crTlg");

var $k8Jq9 = parcelRequire("k8Jq9");

var $iAHhh = parcelRequire("iAHhh");
const $c932533158ff4ee0$var$startApp = ()=>{
    const app = (0, $k8Jq9.initialiseFirebaseApp)();
    (0, $iAHhh.startAuthenticationListener)(app);
    const initApp = (markedVirtues, userEmail)=>{
        const virtues = (0, $6tuu1.getVirtues)(userEmail);
        let state = (0, $e67a97453a06b1d3$export$d4c72bab9d6cc13a)(virtues, markedVirtues, userEmail);
        const eventHandler = (event)=>{
            return function() {
                state = (0, $e67a97453a06b1d3$export$bbfb8c6919cdf161)(event, state);
                $c932533158ff4ee0$var$renderState(state, app);
            };
        };
        const nextHandler = eventHandler((0, $e67a97453a06b1d3$export$3d7865934588d77e).NEXT_EVENT);
        const previousHandler = eventHandler((0, $e67a97453a06b1d3$export$3d7865934588d77e).PREVIOUS_EVENT);
        const dotHandler = eventHandler((0, $e67a97453a06b1d3$export$3d7865934588d77e).TOGGLE_DOT_EVENT);
        $c932533158ff4ee0$var$getNextButton().addEventListener("click", nextHandler);
        $c932533158ff4ee0$var$getPreviousButton().addEventListener("click", previousHandler);
        $c932533158ff4ee0$var$getDotBox().addEventListener("click", dotHandler);
        $c932533158ff4ee0$var$renderState(state, app);
    };
    const virtues = (0, $3GmSf.getCachedMarkedVirtues)();
    const userEmail = (0, $3GmSf.getCachedUserEmail)();
    initApp(virtues, userEmail);
};
addEventListener("DOMContentLoaded", $c932533158ff4ee0$var$startApp);
function $c932533158ff4ee0$var$renderState(state, app) {
    const nextButton = $c932533158ff4ee0$var$getNextButton();
    const previousButton = $c932533158ff4ee0$var$getPreviousButton();
    switch(state.type){
        case (0, $e67a97453a06b1d3$export$92738401e1603719).INITIAL:
            nextButton.innerText = "NEXT";
            previousButton.innerText = "CANCEL";
            break;
        case (0, $e67a97453a06b1d3$export$92738401e1603719).LAST:
            nextButton.innerText = "SUBMIT";
            previousButton.innerText = "PREVIOUS";
            break;
        case (0, $e67a97453a06b1d3$export$92738401e1603719).REVIEW:
            nextButton.innerText = "NEXT";
            previousButton.innerText = "PREVIOUS";
            break;
        case (0, $e67a97453a06b1d3$export$92738401e1603719).CANCEL:
            $c932533158ff4ee0$var$navigateToIndex();
            break;
        case (0, $e67a97453a06b1d3$export$92738401e1603719).SUBMIT:
            {
                const today = new Date();
                const markedVirtues = (0, $e67a97453a06b1d3$export$a950cf0065bb6a87)(state);
                const userEmail = (0, $e67a97453a06b1d3$export$93e1ccb4dacd4b3d)(state);
                const virtueSchemaVersion = (0, $6tuu1.getLatestVirtueSchemaVersion)(userEmail);
                const onError = ()=>{
                    console.warn("failed to store journal entry");
                };
                (0, $3GmSf.storeJournalEntry)(markedVirtues, today, virtueSchemaVersion, app).then($c932533158ff4ee0$var$navigateToIndex).catch(onError);
            }
    }
    const virtue = (0, $e67a97453a06b1d3$export$2196def6041a3ef8)(state);
    $c932533158ff4ee0$var$renderVirtue(virtue);
    const dotted = (0, $e67a97453a06b1d3$export$db8f131360c543a5)(virtue, state);
    $c932533158ff4ee0$var$renderDot(dotted);
}
function $c932533158ff4ee0$var$renderVirtue(virtue) {
    const virtueNameEl = $c932533158ff4ee0$var$getElement("virtue");
    virtueNameEl.innerText = virtue.name;
    const virtueDescriptionEl = $c932533158ff4ee0$var$getElement("virtueDescription");
    virtueDescriptionEl.innerText = virtue.description;
}
function $c932533158ff4ee0$var$renderDot(dotted) {
    const dotEl = $c932533158ff4ee0$var$getElement("dot");
    dotEl.style.visibility = dotted ? "visible" : "hidden";
}
function $c932533158ff4ee0$var$getNextButton() {
    return $c932533158ff4ee0$var$getElement("next-btn");
}
function $c932533158ff4ee0$var$getPreviousButton() {
    return $c932533158ff4ee0$var$getElement("prev-btn");
}
function $c932533158ff4ee0$var$getDotBox() {
    return $c932533158ff4ee0$var$getElement("dotBox");
}
function $c932533158ff4ee0$var$getElement(id) {
    const el = document.getElementById(id);
    (0, $crTlg.assertIsDefined)(el);
    return el;
}
function $c932533158ff4ee0$var$navigateToIndex() {
    window.location.href = "../../index.html";
}


//# sourceMappingURL=review.de8cd6be.js.map
